import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-账户列表",
  "use": "icon-账户列表-usage",
  "viewBox": "0 0 25 19.2333984375",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" fill=\"none\" viewBox=\"0 0 25 19.2333984375\" id=\"icon-账户列表\"><g><g><g><rect x=\"5.132450580596924\" y=\"7.007121562957764\" width=\"19.8675479888916\" height=\"12.226183891296387\" rx=\"2\" fill=\"#39CBFB\" fill-opacity=\"1\" /></g></g><g style=\"mix-blend-mode:multiply\" transform=\"matrix(0.9183593988418579,-0.39574742317199707,0.39574742317199707,0.9183593988418579,-3.1115760787184854,0.6419016947217528)\"><g><rect x=\"0\" y=\"7.86253023147583\" width=\"19.86754608154297\" height=\"12.226184844970703\" rx=\"2\" fill=\"#5578F7\" fill-opacity=\"1\" /></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/账户列表.svg
// module id = cy9Q
// module chunks = 119